import { createFileRoute } from '@tanstack/react-router'
import type { UserProfileUpdate } from '@workspace/seedforge-ui/user-profile'
import { UserProfileView } from '@workspace/seedforge-ui/user-profile'
import { InvestorLayout } from '../../../../components/investor-layout'
import { useInvestorContext } from '../../../../contexts/investor-guard'
import { useUpdateUserMutation } from '../../../../hooks/api'

export const Route = createFileRoute('/app/investor/$id/me')({
  component: InvestorProfilePage,
})

function InvestorProfilePage() {
  const { user } = useInvestorContext()
  const updateUser = useUpdateUserMutation()

  const handleSave = (update: UserProfileUpdate) => {
    updateUser.mutate({ body: update })
  }

  return (
    <InvestorLayout activeNav="">
      <UserProfileView
        profile={{
          name: user.name,
          email: user.email,
          image: user.image,
          bio: user.bio,
          location: user.location,
          websiteUrl: user.websiteUrl,
          linkedinUrl: user.linkedinUrl,
          twitterUrl: user.twitterUrl,
          githubUrl: user.githubUrl,
        }}
        onSave={handleSave}
        isSaving={updateUser.isPending}
        widthClassName="max-w-3xl"
      />
    </InvestorLayout>
  )
}
